import React, { useCallback } from 'react';
import { TypedMemo } from '../../common/types';
import { SMLSmartLinksHomeProps } from './props';
import { useGetAccountQuery } from '../../../redux/api/fymAPI';
import { LoadingView } from '../../common/views/LoadingView';
import { SMLSmartLinksHomeRenderer } from './SMLSmartLinksHomeRenderer';
import { ErrorView } from '../../common/views/ErrorView/ErrorView';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { SMLContainer } from '../smlContainer/SMLContainer';

const SMLSmartLinksHomeComponent: React.FC<SMLSmartLinksHomeProps> = ({ accountId }) => {
  const router = useSMLRouter();
  const {
    data: accountResponse,
    isLoading: isLoadingAccount,
    error: accountError,
    refetch: accountRefetch,
  } = useGetAccountQuery({ accountId });

  const goToSmartLinksManageView = useCallback(
    (smartLinkId: number) => {
      router.push(SMLRoutes.manage, { accountId, smartLinkId });
    },
    [router, accountId]
  );

  const accountRefetchCallbacked = useCallback(() => {
    accountRefetch().catch(console.log);
  }, [accountRefetch]);
  if (accountError) {
    return <ErrorView error={accountError} retry={accountRefetchCallbacked} />;
  }
  if (!accountResponse || isLoadingAccount) {
    return (
      <SMLContainer header={null}>
        <LoadingView />
      </SMLContainer>
    );
  }

  return <SMLSmartLinksHomeRenderer account={accountResponse.account} onSmartLinkClick={goToSmartLinksManageView} />;
};

export const SMLSmartLinksHome = TypedMemo(SMLSmartLinksHomeComponent);
